

jQuery(document).ready(function () {
  if ($('body').hasClass('p-rivenditori-orologi')) {
    rivenditori('orologi');
  } else if ($('body').hasClass('p-rivenditori-occhiali')) {
    rivenditori('occhiali');
  }

});

function rivenditori(what) {
  let rivenditoriOrologi = [
    {
      "CLIENTE": "APL SRL",
      "WEBSITE": "tupigi.it",
      "URL": "https://tupigi.it/it/orologi-da-polso/?action=apply-filter&manufacturers%5b%5d=664",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "E-COMMERCE",
      "INDIRIZZO": "VIA FERRANTE IMPARATO",
      "CITTA": "NAPOLI",
      "PROV": "NA",
      "CAP": 80146
    },
    {
      "CLIENTE": "GIOIELLERIA ORO & CO",
      "NOME SU INSEGNA NEGOZIO": "ORO & CO.",
      "DESCRIPTION": "",
      "INDIRIZZO": "VIA F. TURATI 30",
      "CITTA": "SAN MARZANO SUL SARNO",
      "PROV": "SA",
      "CAP": 84010
    },
    {
      "CLIENTE": "DIAMONDS GIOIELLERIE SRL",
      "NOME SU INSEGNA NEGOZIO": "GIOIELLERIA ESPOSITO",
      "DESCRIPTION": "",
      "INDIRIZZO": "CORSO MERIDIONALE, 27/28",
      "CITTA": "NAPOLI",
      "PROV": "NA",
      "CAP": 80143
    },
    {
      "CLIENTE": "MONDODORO",
      "NOME SU INSEGNA NEGOZIO": "MONDODORO",
      "DESCRIPTION": "",
      "INDIRIZZO": "VIA ITALIA 61",
      "CITTA": "CAPACCIO PAESTUM",
      "PROV": "SA",
      "CAP": 84047
    },
    {
      "CLIENTE": "GOLDEN SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "E COMMERCE",
      "INDIRIZZO": "ZONA INDUSTRIALE ASI SUD",
      "CITTA": "MARCIANISE",
      "PROV": "CE",
      "CAP": 81025
    },
    {
      "CLIENTE": "VINCENZA BOUTIQUE DI DEL VERME VINCENZA",
      "NOME SU INSEGNA NEGOZIO": "VINCENZA BOUTIQUE",
      "DESCRIPTION": "",
      "INDIRIZZO": "VIA ANGELO RUBINO SNC",
      "CITTA": "VALLO DELLA LUCANIA",
      "PROV": "SA",
      "CAP": 84078
    },
    {
      "CLIENTE": "SCIZIA ORO SAS",
      "NOME SU INSEGNA NEGOZIO": "SCIZIA ORO",
      "DESCRIPTION": "",
      "INDIRIZZO": "VIA UGO BASSI, 14 - 40100 -BOLOGNA",
      "CITTA": "BOLOGNA",
      "PROV": "BO",
      "CAP": 40100
    },
    {
      "CLIENTE": "CARMINE RUOCCO GIOIELLI",
      "NOME SU INSEGNA NEGOZIO": "CARMINE RUOCCO JEWELS",
      "DESCRIPTION": "",
      "INDIRIZZO": "VIA ROMA 29",
      "CITTA": "CAPRI",
      "PROV": "NA",
      "CAP": 80073
    },
    {
      "CLIENTE": "LIMONE GIOIELLI SRL",
      "NOME SU INSEGNA NEGOZIO": "LIMONE GIOIELLI",
      "DESCRIPTION": "",
      "INDIRIZZO": "VIA STRADELLA CATANIA, 47/51",
      "CITTA": "SANTA TERESA DI RIVA",
      "PROV": "ME",
      "CAP": 98028
    },
    {
      "CLIENTE": "KRISHA DI GATTI LUCA",
      "NOME SU INSEGNA NEGOZIO": "DIECI E DIECI",
      "DESCRIPTION": "",
      "INDIRIZZO": "VIA PIETRO ANTONIO MAGATTI 2",
      "CITTA": "VARESE",
      "PROV": "VA",
      "CAP": 21100
    },
    {
      "CLIENTE": "GIOIAPURA (FB SRL)",
      "WEBSITE": "www.gioiapura.it",
      "URL": "https://www.gioiapura.it/barrow-B384.htm",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "E-COMMERCE",
      "INDIRIZZO": "VIA SACRO MONTE, 1",
      "CITTA": "LOCATE VARESINO",
      "PROV": "CO",
      "CAP": 22070
    },
    {
      "CLIENTE": "ALBA GIOIELLI S.A.S",
      "NOME SU INSEGNA NEGOZIO": "ALBA GIOIELLI",
      "DESCRIPTION": "",
      "INDIRIZZO": "VIA PRINCIPE DI PIEMONTE, 30",
      "CITTA": "CASORIA",
      "PROV": "NA",
      "CAP": 80026
    },
    {
      "CLIENTE": "LC GIOIELLI DI BARONELLI GIUSEPPE",
      "NOME SU INSEGNA NEGOZIO": "LC GIOIELLI",
      "DESCRIPTION": "",
      "INDIRIZZO": "VIA RUGGIERI 6",
      "CITTA": "SCORDIA",
      "PROV": "CT",
      "CAP": 95048
    },
    {
      "CLIENTE": "GIOELLERIA MONDO ORO DI SPECCHIA DEBORA ANTONELLA",
      "NOME SU INSEGNA NEGOZIO": "MONDO ORO GIOIELLERIA",
      "DESCRIPTION": "CAVALLINO CENTRO COMMERCIALE",
      "INDIRIZZO": "SS 16 LECCE-MAGLIE KM962",
      "CITTA": "CAVALLINO",
      "PROV": "LE",
      "CAP": 73020
    },
    {
      "CLIENTE": "SECCHIAROLI DANIELA",
      "NOME SU INSEGNA NEGOZIO": "IRIS BJOUX",
      "DESCRIPTION": "",
      "INDIRIZZO": "VIA DANTE, 3 - RICCIONE 47838",
      "CITTA": "RICCIONE",
      "PROV": "RN",
      "CAP": 47838
    },
    {
      "CLIENTE": "PIC CLOCK DI CHIRICO CLAUDIA & C. SAS",
      "NOME SU INSEGNA NEGOZIO": "PC GIOIELLI",
      "DESCRIPTION": "",
      "INDIRIZZO": "C.SO NICOTERA, 168",
      "CITTA": "LAMEZIA TERME",
      "PROV": "CZ",
      "CAP": 88046
    },
    {
      "CLIENTE": "GIOELLERIA PESCHECHERA COSIMO DAMIANO",
      "NOME SU INSEGNA NEGOZIO": "PREZIOSI PESCHECHERA",
      "DESCRIPTION": "",
      "INDIRIZZO": "VIA CANOSA, 42",
      "CITTA": "BARLETTA",
      "PROV": "BT",
      "CAP": 76121
    },
    {
      "CLIENTE": "SOLHAMBRA DI GIOVANNI GUGLIELMINO SRL",
      "NOME SU INSEGNA NEGOZIO": "SOLHAMBRA GIOIELLERIE",
      "DESCRIPTION": "",
      "INDIRIZZO": "VIA GALLIPOLI, 206",
      "CITTA": "GIARRE",
      "PROV": "CT",
      "CAP": 95014
    },
    {
      "CLIENTE": "SOLHAMBRA DI GIOVANNI GUGLIELMINO SRL",
      "NOME SU INSEGNA NEGOZIO": "SOLHAMBRA GIOIELLERIE",
      "DESCRIPTION": "CENTRO COMMERCIALE CENTOR SICILIA",
      "INDIRIZZO": "SP54",
      "CITTA": "MISTERBIANCO",
      "PROV": "CT",
      "CAP": 95045
    },
    {
      "CLIENTE": "PREZIOSE FOLLIE",
      "NOME SU INSEGNA NEGOZIO": "PREZIOSE FOLLIE",
      "DESCRIPTION": "",
      "INDIRIZZO": "VIA DEL PASSETTO, 111",
      "CITTA": "FIORENTINO",
      "PROV": "SM",
      "CAP": 47897
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "I GIGLI",
      "INDIRIZZO": "VIA S. QUIRICO L. CAPALLE, 165",
      "CITTA": "CAMPI BISENZIO",
      "PROV": "FI",
      "CAP": 50013
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "LE VELE",
      "INDIRIZZO": "LOC. SU IDANU",
      "CITTA": "CAGLIARI",
      "PROV": "CA",
      "CAP": "09044"
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "AUCHAN PORTE DI SASSARI",
      "INDIRIZZO": "LOC. PREDDA NIEDDA",
      "CITTA": "SASSARI",
      "PROV": "SS",
      "CAP": "07100"
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PORTA DI ROMA",
      "INDIRIZZO": "VIA ALBERTO LIONELLO, 201",
      "CITTA": "BUFALOTTA ROMA",
      "PROV": "RM",
      "CAP": "00139"
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "IL CENTRO",
      "INDIRIZZO": "VIALE GIUSEPPE EUGENIO LURAGHI",
      "CITTA": "ARESE",
      "PROV": "MI",
      "CAP": 20020
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CAROSELLO",
      "INDIRIZZO": "S.P. N. 208 KM 2",
      "CITTA": "CARUGATE",
      "PROV": "MI",
      "CAP": 20061
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "ORIO CENTER",
      "INDIRIZZO": "VIA PORTICO, 71",
      "CITTA": "ORIO AL SERIO",
      "PROV": "BG",
      "CAP": 24050
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CONCA D'ORO",
      "INDIRIZZO": "LOC. FONDO RAFFO",
      "CITTA": "PALERMO",
      "PROV": "PA",
      "CAP": 90100
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "",
      "INDIRIZZO": "VIA TORINO, 23",
      "CITTA": "MILANO",
      "PROV": "MI",
      "CAP": 20123
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "I PETALI",
      "INDIRIZZO": "P.LE AZZURRI D'ITALIA",
      "CITTA": "REGGIO EMILIA",
      "PROV": "RE",
      "CAP": 42121
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "FORUM",
      "INDIRIZZO": "LOC. ROCCELLA",
      "CITTA": "PALERMO",
      "PROV": "PA",
      "CAP": 90124
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "GRAN SHOPPING MONGOLFIERA",
      "INDIRIZZO": "VIA OLIVETTI ZONA INDUSTRIALE",
      "CITTA": "MOLFETTA",
      "PROV": "BA",
      "CAP": 70056
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CENTRO CITTÀ",
      "INDIRIZZO": "VIA DEL CORSO, 95",
      "CITTA": "ROMA",
      "PROV": "RM",
      "CAP": "00186"
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CENTRO CITTÀ",
      "INDIRIZZO": "VIA FELICE CASATI, 2",
      "CITTA": "MILANO",
      "PROV": "MI",
      "CAP": 20124
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CENTRO CITTÀ",
      "INDIRIZZO": "VIA XX SETTEMBRE, 226",
      "CITTA": "GENOVA",
      "PROV": "GE",
      "CAP": 16121
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CENTRO CITTÀ",
      "INDIRIZZO": "VIA TOLEDO, 292 293",
      "CITTA": "NAPOLI",
      "PROV": "NA",
      "CAP": 80132
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "SHOPVILLE GRAN RENO",
      "INDIRIZZO": "VIA MARYLIN MONROE, 2",
      "CITTA": "CASALECCHIO DI RENO",
      "PROV": "BO",
      "CAP": 40033
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CENTRO CITTÀ",
      "INDIRIZZO": "VIA MATTEOTTI, 159",
      "CITTA": "SANREMO",
      "PROV": "IM",
      "CAP": 18038
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PORTE DI CATANIA",
      "INDIRIZZO": "VIA GELSO BIANCO",
      "CITTA": "CATANIA",
      "PROV": "CT",
      "CAP": 95121
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CASILINO",
      "INDIRIZZO": "VIA CASILINA, 1011",
      "CITTA": "ROMA",
      "PROV": "RM",
      "CAP": "00169"
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CENTRO CITTÀ",
      "INDIRIZZO": "CORSO V. EMANUELE, 243-245-247",
      "CITTA": "SALERNO",
      "PROV": "SA",
      "CAP": 84122
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CENTRO CITTÀ",
      "INDIRIZZO": "VIA DEL GIGLIO, 67",
      "CITTA": "EMPOLI",
      "PROV": "FI",
      "CAP": 50053
    },
    {
      "CLIENTE": "GIOIELLERIA STROILI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "GRANROMA",
      "INDIRIZZO": "VIA ARISTIDE MERLONI SNC",
      "CITTA": "ROMA",
      "PROV": "RM",
      "CAP": "00155"
    },
    {
      "CLIENTE": "GIOIELLERIA IACCARINO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PIANO DI SORRENTO",
      "INDIRIZZO": "CORSO ITALIA, 90",
      "CITTA": "NAPOLI",
      "PROV": "NA",
      "CAP": "80063"
    },
    {
      "CLIENTE": "3P COMMERCIALE SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "TORRI DI QUARTESOLO",
      "INDIRIZZO": "VIA POLA, 20",
      "CITTA": "VICENZA",
      "PROV": "VI",
      "CAP": "36040"
    },
    {
      "CLIENTE": "GIOIELLERIA LUCCHESE SAS",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "VERBICARO",
      "INDIRIZZO": "VIA ROMA, 85",
      "CITTA": "VERBICARO",
      "PROV": "CS",
      "CAP": "87020"
    },
    {
      "CLIENTE": "SCINTILLE SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "COSENZA",
      "INDIRIZZO": "VIA MONTESANTO, 119",
      "CITTA": "COSENZA",
      "PROV": "CS",
      "CAP": "87100"
    },
    {
      "CLIENTE": "LAX DI LAURA BARTORELLI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "RIMINI",
      "INDIRIZZO": "CORSO D'AUGUSTO, 140",
      "CITTA": "RIMINI",
      "PROV": "RN",
      "CAP": "47921"
    },
    {
      "CLIENTE": "CENTROROLOGI DI ATTIVISSIMO ALEX",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "BITONTO",
      "INDIRIZZO": "VIA MAZZINI, 17/17A",
      "CITTA": "BITONTO",
      "PROV": "BA",
      "CAP": "70032"
    },
    {
      "CLIENTE": "GIOIELLI SPATARO  BRUNO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "SIDERNO",
      "INDIRIZZO": "CORSO DELLA REPUBBLICA, 97",
      "CITTA": "SIDERNO",
      "PROV": "RC",
      "CAP": "89048"
    },
    {
      "CLIENTE": "ADAMAI SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "LADISPOLI",
      "INDIRIZZO": "VIALE ITALIA, 59/A",
      "CITTA": "LADISPOLI",
      "PROV": "RM",
      "CAP": "00055"
    },
    {
      "CLIENTE": "ALBERTI ROBERTO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "BIBIONE",
      "INDIRIZZO": "VIALE AURORA, 4",
      "CITTA": "BIBIONE",
      "PROV": "VE",
      "CAP": "30028"
    }
  ];


  let rivenditoriOcchiali = [
    {
      "CLIENTE": "DANILOPIORELLI SAS",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "VASTO",
      "INDIRIZZO": "CIRCONVALLAZIONE ISTONIENSE 9/B",
      "CITTA": "VASTO",
      "PROV": "CH",
      "CAP": 66054,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA SERVADIO SNC",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PESCARA",
      "INDIRIZZO": "VIA VENEZIA 12/9",
      "CITTA": "PESCARA",
      "PROV": "PE",
      "CAP": 65121,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA ALBAVISION SNC",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "ALBA ADRIATICA",
      "INDIRIZZO": "VIA MAZZINI  154",
      "CITTA": "ALBA ADRIATICA",
      "PROV": "TE",
      "CAP": 64011,
      "STATE": "IT"
    },
    {
      "CLIENTE": "FOTOTTICA CICCIA SAS",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "AMANTEA",
      "INDIRIZZO": "CORSO VITTORIO EMANUELE 69",
      "CITTA": "AMANTEA",
      "PROV": "CS",
      "CAP": 87032,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICO AMBROSIO & C. SNC",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "COSENZA",
      "INDIRIZZO": "CORSO GIUSEPPE MAZZINI  216",
      "CITTA": "COSENZA",
      "PROV": "CS",
      "CAP": 87100,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA CENTER SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "MAIDA - LAMEZIA TERME",
      "INDIRIZZO": "LOC. COMUNI CONDOMINI",
      "CITTA": "MAIDA - LAMEZIA TERME",
      "PROV": "CZ",
      "CAP": 88025,
      "STATE": "IT"
    },
    {
      "CLIENTE": "SOLE MARE OTTICA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "TROPEA",
      "INDIRIZZO": "VIA PIETRO VIANEO 2",
      "CITTA": "TROPEA",
      "PROV": "VV",
      "CAP": 89861,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA DE PASQUALE",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "ARIANO IRPINO",
      "INDIRIZZO": "VIA ROMA 17",
      "CITTA": "ARIANO IRPINO",
      "PROV": "AV",
      "CAP": 83031,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA LUNETTES",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "ATRIPALDA",
      "INDIRIZZO": "VIA ROMA  69",
      "CITTA": "ATRIPALDA",
      "PROV": "AV",
      "CAP": 83042,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA MARTINEZ SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "AVELLINO",
      "INDIRIZZO": "VIA CIRCUMVALLAZIONE  37",
      "CITTA": "AVELLINO",
      "PROV": "AV",
      "CAP": 83100,
      "STATE": "IT"
    },
    {
      "CLIENTE": "LONARDO SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "BENEVENTO",
      "INDIRIZZO": "VIA NAPOLI  44",
      "CITTA": "BENEVENTO",
      "PROV": "BN",
      "CAP": 82100,
      "STATE": "IT"
    },
    {
      "CLIENTE": "MEETING  SRL UNIPERSONALE",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CASERTA",
      "INDIRIZZO": "VIA POZZILLO",
      "CITTA": "CASERTA",
      "PROV": "CE",
      "CAP": 81100,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA EXPRESS",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "FALCIANO DEL MASSICO",
      "INDIRIZZO": "CORSO ORIENTE 95",
      "CITTA": "FALCIANO DEL MASSICO",
      "PROV": "CE",
      "CAP": 81030,
      "STATE": "IT"
    },
    {
      "CLIENTE": "TECNOPTICA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "MARCIANISE",
      "INDIRIZZO": "VIA ROMA  2-4-6",
      "CITTA": "MARCIANISE",
      "PROV": "CE",
      "CAP": 81025,
      "STATE": "IT"
    },
    {
      "CLIENTE": "CASALINO OTTICA SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "SANTA MARIA A VICO",
      "INDIRIZZO": "VIA NAZIONALE APPIA  219/221",
      "CITTA": "SANTA MARIA A VICO",
      "PROV": "CE",
      "CAP": 81028,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA OPTI MED",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "ARZANO",
      "INDIRIZZO": "VIA ALFREDO PECCHIA  117",
      "CITTA": "ARZANO",
      "PROV": "NA",
      "CAP": 80022,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OPTICAL CAPRI SAS",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CAPRI",
      "INDIRIZZO": "VIA LE BOTTEGHE 27",
      "CITTA": "CAPRI",
      "PROV": "NA",
      "CAP": 80073,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA VAIRO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CARDITO",
      "INDIRIZZO": "VIA PIETRO DONADIO  114",
      "CITTA": "CARDITO",
      "PROV": "NA",
      "CAP": 80024,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA RUSSO  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CASTELLAMMARE DI STABIA",
      "INDIRIZZO": "VIALE EUROPA  121",
      "CITTA": "CASTELLAMMARE DI STABIA",
      "PROV": "NA",
      "CAP": 80053,
      "STATE": "IT"
    },
    {
      "CLIENTE": "IMMAGINI SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "ERCOLANO",
      "INDIRIZZO": "PIAZZA TRIESTE, 5",
      "CITTA": "ERCOLANO",
      "PROV": "NA",
      "CAP": 80056,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA LETTERA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "FRATTAMAGGIORE",
      "INDIRIZZO": "VIA XXXI MAGGIO  31/33",
      "CITTA": "FRATTAMAGGIORE",
      "PROV": "NA",
      "CAP": 80027,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA BRANDI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "NAPOLI",
      "INDIRIZZO": "CORSO GARIBALDI  197",
      "CITTA": "NAPOLI",
      "PROV": "NA",
      "CAP": 80141,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OCCHIALI TR&.1  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "NAPOLI",
      "INDIRIZZO": "VIA RAFFAELE RUGGIERO  119",
      "CITTA": "NAPOLI",
      "PROV": "NA",
      "CAP": 80125,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA NAPOLITANO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "POMIGLIANO D'ARCO",
      "INDIRIZZO": "CORSO VITTORIO EMANUELE  166/168",
      "CITTA": "POMIGLIANO D'ARCO",
      "PROV": "NA",
      "CAP": 80038,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA ABBATI SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "POMIGLIANO D'ARCO",
      "INDIRIZZO": "VIA ROMA  16",
      "CITTA": "POMIGLIANO D'ARCO",
      "PROV": "NA",
      "CAP": 80038,
      "STATE": "IT"
    },
    {
      "CLIENTE": "DITTA MAURO  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "TORRE DEL GRECO",
      "INDIRIZZO": "VIA NAZIONALE  130-132",
      "CITTA": "TORRE DEL GRECO",
      "PROV": "NA",
      "CAP": 80059,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA FOCUS POINT",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "AGROPOLI",
      "INDIRIZZO": "VIA ALCIDE DE GASPERI 11/C",
      "CITTA": "AGROPOLI",
      "PROV": "SA",
      "CAP": 84043,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA BASSANO SAS",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "BATTIPAGLIA",
      "INDIRIZZO": "VIA MAZZINI  41/45",
      "CITTA": "BATTIPAGLIA",
      "PROV": "SA",
      "CAP": 84091,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA BISOGNO MASSIMO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "ROCCAPIEMONTE",
      "INDIRIZZO": "VIA PONTE  17",
      "CITTA": "ROCCAPIEMONTE",
      "PROV": "SA",
      "CAP": 84086,
      "STATE": "IT"
    },
    {
      "CLIENTE": "CENTRO OTTICO VEDO CHIARO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "SALA CONSILINA",
      "INDIRIZZO": "VIA GODELMO 132",
      "CITTA": "SALA CONSILINA",
      "PROV": "SA",
      "CAP": 84036,
      "STATE": "IT"
    },
    {
      "CLIENTE": "ASTANZA  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "SANTA MARIA DI CASTELLABATE",
      "INDIRIZZO": "VIA S.S.  267",
      "CITTA": "SANTA MARIA DI CASTELLABATE",
      "PROV": "SA",
      "CAP": 84048,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA GIULIETTI E GUERRA SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "BOLOGNA",
      "INDIRIZZO": "VIA CLAVATURE  24",
      "CITTA": "BOLOGNA",
      "PROV": "BO",
      "CAP": 40124,
      "STATE": "IT"
    },
    {
      "CLIENTE": "C.O. GUIDORENI - RIF. PIACENZA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "BOLOGNA",
      "INDIRIZZO": "VIA DELL'INDIPENDENZA  24",
      "CITTA": "BOLOGNA",
      "PROV": "BO",
      "CAP": 40121,
      "STATE": "IT"
    },
    {
      "CLIENTE": "NOVA SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CASALECCHIO DI RENO",
      "INDIRIZZO": "VIA ALDO MORO  18",
      "CITTA": "CASALECCHIO DI RENO",
      "PROV": "BO",
      "CAP": 40033,
      "STATE": "IT"
    },
    {
      "CLIENTE": "PUNTO DI VISTA  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "BONDENO",
      "INDIRIZZO": "PIAZZA GIUSEPPE GARIBALDI  99/A",
      "CITTA": "BONDENO",
      "PROV": "FE",
      "CAP": 44012,
      "STATE": "IT"
    },
    {
      "CLIENTE": "CENTOTTICA SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CENTO",
      "INDIRIZZO": "VIA GIACOMO MATTEOTTI  3",
      "CITTA": "CENTO",
      "PROV": "FE",
      "CAP": 44042,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA GIULIANELLI  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "FERRARA",
      "INDIRIZZO": "VIA BORGO DEI LEONI  42",
      "CITTA": "FERRARA",
      "PROV": "FE",
      "CAP": 44121,
      "STATE": "IT"
    },
    {
      "CLIENTE": "LA LENTE\"  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "FERRARA",
      "INDIRIZZO": "VIA GIUSEPPE GARIBALDI  139/141A",
      "CITTA": "FERRARA",
      "PROV": "FE",
      "CAP": 44121,
      "STATE": "IT"
    },
    {
      "CLIENTE": "DIECI DECIMI - SHOPTIC 43 SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "FERRARA",
      "INDIRIZZO": "CORSO MARTIRI DELLA LIBERTA'  32/34",
      "CITTA": "FERRARA",
      "PROV": "FE",
      "CAP": 44121,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA MODERNA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "FERRARA",
      "INDIRIZZO": "VIA ZAPPATERRA 9",
      "CITTA": "FERRARA",
      "PROV": "FE",
      "CAP": 24122,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA FLLI LUGLI  SNC",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CARPI",
      "INDIRIZZO": "CORSO ALBERTO PIO  32",
      "CITTA": "CARPI",
      "PROV": "MO",
      "CAP": 41012,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA DUEMILA SNC",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "FORMIGINE",
      "INDIRIZZO": "VIA SAN GIOVANNI BOSCO  1",
      "CITTA": "FORMIGINE",
      "PROV": "MO",
      "CAP": 41043,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA OPTOMETRIA RIGHETTI SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "MODENA",
      "INDIRIZZO": "VIA EMILIA CENTRO 140",
      "CITTA": "MODENA",
      "PROV": "MO",
      "CAP": 41121,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA MODERNA SNC",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "MODENA",
      "INDIRIZZO": "VIA EMILIA CENTRO  309",
      "CITTA": "MODENA",
      "PROV": "MO",
      "CAP": 41121,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA MONTESE",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "MONTESE",
      "INDIRIZZO": "VIA TAMBURINI  31",
      "CITTA": "MONTESE",
      "PROV": "MO",
      "CAP": 41055,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA AMIDEI SNC",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "VIGNOLA",
      "INDIRIZZO": "CORSO ITALIA  36",
      "CITTA": "VIGNOLA",
      "PROV": "MO",
      "CAP": 41058,
      "STATE": "IT"
    },
    {
      "CLIENTE": "EYE OPTIC  SRLS",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CARPANETO PIACENTINO",
      "INDIRIZZO": "VIA CESARE BATTISTI  9",
      "CITTA": "CARPANETO PIACENTINO",
      "PROV": "PC",
      "CAP": 29013,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA PAGANI SAS",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PIACENZA",
      "INDIRIZZO": "PIAZZA DUOMO  6",
      "CITTA": "PIACENZA",
      "PROV": "PC",
      "CAP": 29121,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA BELTRAMI SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "LANGHIRANO",
      "INDIRIZZO": "VIA MAZZINI  34",
      "CITTA": "LANGHIRANO",
      "PROV": "PR",
      "CAP": 43013,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OPTILOOK SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PARMA",
      "INDIRIZZO": "VIA EMILIO LEPIDO  43/A",
      "CITTA": "PARMA",
      "PROV": "PR",
      "CAP": 43123,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA CENTRO TORRI SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PARMA",
      "INDIRIZZO": "VIA SAN LEONARDO  69/A INT. 2",
      "CITTA": "PARMA",
      "PROV": "PR",
      "CAP": 43122,
      "STATE": "IT"
    },
    {
      "CLIENTE": "DIECI DECIMI - SHOPTIC 43 SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "FAENZA",
      "INDIRIZZO": "CORSO GIUSEPPE MAZZINI  25/A",
      "CITTA": "FAENZA",
      "PROV": "RA",
      "CAP": 48018,
      "STATE": "IT"
    },
    {
      "CLIENTE": "CENTRO OTTICO GUIDORENI  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "REGGIO EMILIA",
      "INDIRIZZO": "VIALE RODOLFO MORANDI  12",
      "CITTA": "REGGIO EMILIA",
      "PROV": "RE",
      "CAP": 42123,
      "STATE": "IT"
    },
    {
      "CLIENTE": "REMGLASS SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "REGGIO EMILIA",
      "INDIRIZZO": "VIA CAFIERO 2/B",
      "CITTA": "REGGIO EMILIA",
      "PROV": "RE",
      "CAP": 42124,
      "STATE": "IT"
    },
    {
      "CLIENTE": "ATELIER OTTICO SAS",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "SCANDIANO",
      "INDIRIZZO": "CORSO VALLISNERI  14 A/B",
      "CITTA": "SCANDIANO",
      "PROV": "RE",
      "CAP": 42019,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA  MC",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "REPUBBLICA SAN MARINO",
      "INDIRIZZO": "VIA SALITA ALLA ROCCA  21",
      "CITTA": "REPUBBLICA SAN MARINO",
      "PROV": "SM",
      "CAP": 47890,
      "STATE": "IT"
    },
    {
      "CLIENTE": "VISTA PIU'  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "MONFALCONE",
      "INDIRIZZO": "VIA AUGUSTO COLOMBO 6/6",
      "CITTA": "MONFALCONE",
      "PROV": "GO",
      "CAP": 34074,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA INN",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "TRIESTE",
      "INDIRIZZO": "VIA CONTI  36",
      "CITTA": "TRIESTE",
      "PROV": "TS",
      "CAP": 34141,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA GIORNALFOTO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "TRIESTE",
      "INDIRIZZO": "PIAZZA DELLA BORSA 8",
      "CITTA": "TRIESTE",
      "PROV": "TS",
      "CAP": 34121,
      "STATE": "IT"
    },
    {
      "CLIENTE": "STAR SAS",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "LIGNANO SABBIADORO",
      "INDIRIZZO": "VIALE VENEZIA 87",
      "CITTA": "LIGNANO SABBIADORO",
      "PROV": "UD",
      "CAP": 33054,
      "STATE": "IT"
    },
    {
      "CLIENTE": "MEGAVISION  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "REANA DEL ROJALE",
      "INDIRIZZO": "VIA NAZIONALE 19",
      "CITTA": "REANA DEL ROJALE",
      "PROV": "UD",
      "CAP": 33010,
      "STATE": "IT"
    },
    {
      "CLIENTE": "COMELSTILE  SNC",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "TOLMEZZO",
      "INDIRIZZO": "VIA PROMETEO CANDONI  13",
      "CITTA": "TOLMEZZO",
      "PROV": "UD",
      "CAP": 33028,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA BUCCIARELLI SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CECCANO",
      "INDIRIZZO": "VIA FABRATERIA VETUS 1",
      "CITTA": "CECCANO",
      "PROV": "FR",
      "CAP": "03023",
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA DI VOSSOLI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PONTECORVO",
      "INDIRIZZO": "VIA XXIV MAGGIO  7",
      "CITTA": "PONTECORVO",
      "PROV": "FR",
      "CAP": "03037",
      "STATE": "IT"
    },
    {
      "CLIENTE": "LOGITEC SPA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "FIUMICINO",
      "INDIRIZZO": "VIA FRANCESCO DE PINEDO SNC",
      "CITTA": "FIUMICINO",
      "PROV": "RM",
      "CAP": "00054",
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA FRANCESCO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "OSTIA LIDO",
      "INDIRIZZO": "VIA ISOLE DEL CAPOVERDE  168",
      "CITTA": "OSTIA LIDO",
      "PROV": "RM",
      "CAP": "00121",
      "STATE": "IT"
    },
    {
      "CLIENTE": "AMEVISTA SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "ROMA",
      "INDIRIZZO": "VIA FLAMINIA 844",
      "CITTA": "ROMA",
      "PROV": "RM",
      "CAP": "00191",
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA LAGANI  SAS",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "RAPALLO",
      "INDIRIZZO": "CORSO GIACOMO MATTEOTTI 23",
      "CITTA": "RAPALLO",
      "PROV": "GE",
      "CAP": 16035,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OPTILAB SRL - RIF. TRAVAGLIATO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "GORLAGO",
      "INDIRIZZO": "VIA PRIMO MAGGIO 3C",
      "CITTA": "GORLAGO",
      "PROV": "BG",
      "CAP": 24060,
      "STATE": "IT"
    },
    {
      "CLIENTE": "PROGETTO 2017  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "MONZA",
      "INDIRIZZO": "VIA VITTORIO EMANUELE II 19",
      "CITTA": "MONZA",
      "PROV": "MB",
      "CAP": 20900,
      "STATE": "IT"
    },
    {
      "CLIENTE": "ANNIBALE SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "LIVIGNO",
      "INDIRIZZO": "VIA DALA GESA 20",
      "CITTA": "LIVIGNO",
      "PROV": "SO",
      "CAP": 23041,
      "STATE": "IT"
    },
    {
      "CLIENTE": "L'OTTICA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CINGOLI",
      "INDIRIZZO": "BORGO PAOLO DANTI 27/29/31",
      "CITTA": "CINGOLI",
      "PROV": "MC",
      "CAP": 62011,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA GLORIA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "ISERNIA",
      "INDIRIZZO": "VIA LIBERO TESTA  95",
      "CITTA": "ISERNIA",
      "PROV": "IS",
      "CAP": 86170,
      "STATE": "IT"
    },
    {
      "CLIENTE": "ARTE OTTICA SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "MOLFETTA",
      "INDIRIZZO": "VIA PRINCIPE AMEDEO  41/43",
      "CITTA": "MOLFETTA",
      "PROV": "BA",
      "CAP": 70056,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA NACCI GIUSEPPE",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "OSTUNI",
      "INDIRIZZO": "VIA PANORAMICA",
      "CITTA": "OSTUNI",
      "PROV": "BR",
      "CAP": 72017,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA CONVERTINI LUIGI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "BARLETTA",
      "INDIRIZZO": "VIA FERDINANDO D'ARAGONA  75/77",
      "CITTA": "BARLETTA",
      "PROV": "BT",
      "CAP": 76121,
      "STATE": "IT"
    },
    {
      "CLIENTE": "CENTRO OTTICO DI MOLFETTA MARIA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "BISCEGLIE",
      "INDIRIZZO": "VIA LA FONTE  5/7",
      "CITTA": "BISCEGLIE",
      "PROV": "BT",
      "CAP": 76011,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA BIANCOFIORE SNC",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "SAN GIOVANNI ROTONDO",
      "INDIRIZZO": "CORSO UMBERTO I  93",
      "CITTA": "SAN GIOVANNI ROTONDO",
      "PROV": "FG",
      "CAP": 71013,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA TOMA TIZIANA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "ALLISTE",
      "INDIRIZZO": "VIA ROMA  6",
      "CITTA": "ALLISTE",
      "PROV": "LE",
      "CAP": 73040,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA SURDO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "MARTANO",
      "INDIRIZZO": "VIA MARCONI  99",
      "CITTA": "MARTANO",
      "PROV": "LE",
      "CAP": 73025,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA CIURLIA COSIMO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "TRICASE",
      "INDIRIZZO": "VIA L. CADORNA ANG. VIA DIAZ 80",
      "CITTA": "TRICASE",
      "PROV": "LE",
      "CAP": 73039,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA DETTOLI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PALAGIANELLO",
      "INDIRIZZO": "CORSO ANTONIO GRAMSCI",
      "CITTA": "PALAGIANELLO",
      "PROV": "TA",
      "CAP": 74018,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA LOCCI LUANA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "QUARTU SANT'ELENA",
      "INDIRIZZO": "VIA FIUME  187",
      "CITTA": "QUARTU SANT'ELENA",
      "PROV": "CA",
      "CAP": "09045",
      "STATE": "IT"
    },
    {
      "CLIENTE": "MIKI SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "SESTU",
      "INDIRIZZO": "EX SS 131 KM 8,00",
      "CITTA": "SESTU",
      "PROV": "CA",
      "CAP": "09028",
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA LES LUNETTES",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "SETTIMO SAN PIETRO",
      "INDIRIZZO": "VIA SAN SALVATORE 121",
      "CITTA": "SETTIMO SAN PIETRO",
      "PROV": "CA",
      "CAP": "09040",
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA BRESSAN SERGIO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "LA MADDALENA",
      "INDIRIZZO": "VIA GARIBALDI  44",
      "CITTA": "LA MADDALENA",
      "PROV": "SS",
      "CAP": "07024",
      "STATE": "IT"
    },
    {
      "CLIENTE": "EASY VISION",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "ISILI",
      "INDIRIZZO": "CORSO VITTORIO EMANUELE  148/150",
      "CITTA": "ISILI",
      "PROV": "SU",
      "CAP": "08033",
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA SACCO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "AGRIGENTO",
      "INDIRIZZO": "PIAZZA SAN CALOGERO 1/3",
      "CITTA": "AGRIGENTO",
      "PROV": "AG",
      "CAP": 92100,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA SACCO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "SCIACCA",
      "INDIRIZZO": "VIA CAPPUCCINI 2",
      "CITTA": "SCIACCA",
      "PROV": "AG",
      "CAP": 92019,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OCCHIALISSIMI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "BIANCAVILLA",
      "INDIRIZZO": "VIA CRISTOFORO COLOMBO 355/357",
      "CITTA": "BIANCAVILLA",
      "PROV": "CT",
      "CAP": 95033,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA CAMPAGNA  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CATANIA",
      "INDIRIZZO": "CORSO ITALIA  15",
      "CITTA": "CATANIA",
      "PROV": "CT",
      "CAP": 95129,
      "STATE": "IT"
    },
    {
      "CLIENTE": "VISUAL OTTICA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "MISTERBIANCO",
      "INDIRIZZO": "VIA BRUNO BUOZZI, 4/6",
      "CITTA": "MISTERBIANCO",
      "PROV": "CT",
      "CAP": 95045,
      "STATE": "IT"
    },
    {
      "CLIENTE": "PUNTO SOLE",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PATERNO'",
      "INDIRIZZO": "VIA DELLA LIBERTA'  61/A",
      "CITTA": "PATERNO'",
      "PROV": "CT",
      "CAP": 95047,
      "STATE": "IT"
    },
    {
      "CLIENTE": "TECNOTTICA DI RUSSO SALVATORE",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "RANDAZZO",
      "INDIRIZZO": "VIA UMBERTO  2",
      "CITTA": "RANDAZZO",
      "PROV": "CT",
      "CAP": 95036,
      "STATE": "IT"
    },
    {
      "CLIENTE": "ISTITUTO OTTICO MONDELLO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "BARCELLONA POZZO DI GOTTO",
      "INDIRIZZO": "PIAZZA DUOMO 13",
      "CITTA": "BARCELLONA POZZO DI GOTTO",
      "PROV": "ME",
      "CAP": 98051,
      "STATE": "IT"
    },
    {
      "CLIENTE": "VISIONOTTICA MIGLIORISI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "MESSINA",
      "INDIRIZZO": "SS 114 KM 4.02",
      "CITTA": "MESSINA",
      "PROV": "ME",
      "CAP": 98125,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA ARMARO MARIA TINA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "TORRENOVA",
      "INDIRIZZO": "VIA BENEDETTO CAPUTO 111",
      "CITTA": "TORRENOVA",
      "PROV": "ME",
      "CAP": 98070,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA LA MANTIA ROCCO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PALERMO",
      "INDIRIZZO": "VIA DELL'ORSA MINORE  110",
      "CITTA": "PALERMO",
      "PROV": "PA",
      "CAP": 90124,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA LA MANTIA SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PALERMO",
      "INDIRIZZO": "VIA VILLAGRAZIA 77",
      "CITTA": "PALERMO",
      "PROV": "PA",
      "CAP": 90124,
      "STATE": "IT"
    },
    {
      "CLIENTE": "ARTE IN OTTICA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PARTINICO",
      "INDIRIZZO": "VIA CANALETTO 1",
      "CITTA": "PARTINICO",
      "PROV": "PA",
      "CAP": 90047,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA QUARTARONE",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "POZZALLO",
      "INDIRIZZO": "CORSO VITTORIO VENETO  51",
      "CITTA": "POZZALLO",
      "PROV": "RG",
      "CAP": 97016,
      "STATE": "IT"
    },
    {
      "CLIENTE": "BONURA  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "RAGUSA",
      "INDIRIZZO": "CORSO ITALIA  134",
      "CITTA": "RAGUSA",
      "PROV": "RG",
      "CAP": 97100,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA VOGUE",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "MARSALA",
      "INDIRIZZO": "VIA EDOARDO ALAGNA  10",
      "CITTA": "MARSALA",
      "PROV": "TP",
      "CAP": 91025,
      "STATE": "IT"
    },
    {
      "CLIENTE": "GUIDORENI DUOMO P.ZA S. GIOVANNI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "FIRENZE",
      "INDIRIZZO": "VIA DELLE TERME  29/R",
      "CITTA": "FIRENZE",
      "PROV": "FI",
      "CAP": 50123,
      "STATE": "IT"
    },
    {
      "CLIENTE": "CENTRO VISIONE SNC",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CAMAIORE",
      "INDIRIZZO": "VIA STADIO  41",
      "CITTA": "CAMAIORE",
      "PROV": "LU",
      "CAP": 55041,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA 2M CDC SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CITTA' DI CASTELLO",
      "INDIRIZZO": "VIA GIUSEPPE DI VITTORIO 1",
      "CITTA": "CITTA' DI CASTELLO",
      "PROV": "PG",
      "CAP": "06012",
      "STATE": "IT"
    },
    {
      "CLIENTE": "MONDOTTICA SRL UNIPERSONALE",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PONTE FELCINO",
      "INDIRIZZO": "VIA DELL'ALA, 16",
      "CITTA": "PONTE FELCINO",
      "PROV": "PG",
      "CAP": "06077",
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA ZOLDAN  SAS",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PONTE NELLE ALPI",
      "INDIRIZZO": "VIALE CADORE  21",
      "CITTA": "PONTE NELLE ALPI",
      "PROV": "BL",
      "CAP": 32014,
      "STATE": "IT"
    },
    {
      "CLIENTE": "VISION TRADE SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CASALSERUGO",
      "INDIRIZZO": "VIA DELL'ARTIGIANATO 5 INT. 1",
      "CITTA": "CASALSERUGO",
      "PROV": "PD",
      "CAP": 35020,
      "STATE": "IT"
    },
    {
      "CLIENTE": "FOTO OTTICA PICCOLO TIZIANO",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PIEVE DI CURTAROLO",
      "INDIRIZZO": "PIAZZA C.A. DALLA CHIESA  34",
      "CITTA": "PIEVE DI CURTAROLO",
      "PROV": "PD",
      "CAP": 35010,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OPTICOLOR  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "PONTE SAN NICOLO'",
      "INDIRIZZO": "VIALE AUSTRIA  4",
      "CITTA": "PONTE SAN NICOLO'",
      "PROV": "PD",
      "CAP": 35020,
      "STATE": "IT"
    },
    {
      "CLIENTE": "TOFFOLI 1867  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "ROVIGO",
      "INDIRIZZO": "PIAZZA VITTORIO EMANUELE II  29",
      "CITTA": "ROVIGO",
      "PROV": "RO",
      "CAP": 45100,
      "STATE": "IT"
    },
    {
      "CLIENTE": "VISION SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CODOGNE'",
      "INDIRIZZO": "VIA LEONARDO DA VINCI 10",
      "CITTA": "CODOGNE'",
      "PROV": "TV",
      "CAP": 31013,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA CHIARADIA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CONEGLIANO VENETO",
      "INDIRIZZO": "VIA ROSSELLI 5",
      "CITTA": "CONEGLIANO VENETO",
      "PROV": "TV",
      "CAP": 31015,
      "STATE": "IT"
    },
    {
      "CLIENTE": "MEGAVISION  SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "SAN DONA' DI PIAVE",
      "INDIRIZZO": "VIA COMO  60",
      "CITTA": "SAN DONA' DI PIAVE",
      "PROV": "VE",
      "CAP": 30027,
      "STATE": "IT"
    },
    {
      "CLIENTE": "GIAN GROUP SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "SANTORSO",
      "INDIRIZZO": "VIA EUROPA  41",
      "CITTA": "SANTORSO",
      "PROV": "VI",
      "CAP": 36014,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA LUX SRL",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "CASTEL D'AZZANO",
      "INDIRIZZO": "VIA GUGLIELMO MARCONI 77",
      "CITTA": "CASTEL D'AZZANO",
      "PROV": "VR",
      "CAP": 37060,
      "STATE": "IT"
    },
    {
      "CLIENTE": "IL PUNTO DI VISTA",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "LAZISE",
      "INDIRIZZO": "PIAZZA VITTORIO EMANUELE 42",
      "CITTA": "LAZISE",
      "PROV": "VR",
      "CAP": 37017,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA CINE FOTO FASOLI",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "SAN PIETRO IN CARIANO",
      "INDIRIZZO": "VIA BEETHOVEN  3/E",
      "CITTA": "SAN PIETRO IN CARIANO",
      "PROV": "VR",
      "CAP": 37029,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA NOGARA SAS",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "VAGO DI LAVAGNO",
      "INDIRIZZO": "VIA DON ROBERTO LONARDONI  2/B",
      "CITTA": "VAGO DI LAVAGNO",
      "PROV": "VR",
      "CAP": 37050,
      "STATE": "IT"
    },
    {
      "CLIENTE": "OTTICA PIUBELLO SAS",
      "NOME SU INSEGNA NEGOZIO": "",
      "DESCRIPTION": "VERONA",
      "INDIRIZZO": "VIA NIZZA 13",
      "CITTA": "VERONA",
      "PROV": "VR",
      "CAP": 37121,
      "STATE": "IT"
    }
  ];

  let regions = {
    'ABRUZZO': ['CH', 'PE', 'TE'],
    'CALABRIA': ['CZ', 'CS', 'RC', 'VV'],
    'CAMPANIA': ['NA', 'SA', 'CE', 'BN', 'AV'],
    'EMILIA-ROMAGNA': ['BO', 'RN', 'SM', 'RE', 'FE', 'MO', 'PC', 'PR', 'RA'],
    'FRIULI': ['GO', 'TS', 'UD'],
    'LAZIO': ['RM', 'FR'],
    'LIGURIA': ['GE', 'IM'],
    'LOMBARDIA': ['VA', 'MI', 'CO', 'BG', 'MB', 'SO'],
    'MARCHE': ['MC'],
    'MOLISE': ['IS'],
    'PUGLIA': ['LE', 'BT', 'BA', 'BR', 'FG', 'TA'],
    'SARDEGNA': ['CA', 'SS', 'SU'],
    'SICILIA': ['ME', 'CT', 'PA', 'AG', 'RG', 'TP'],
    'TOSCANA': ['FI', 'LU'],
    'UMBRIA': ['PG'],
    'VENETO': ['VI', 'VE', 'BL', 'PD', 'TV', 'VR', 'RO'],

  };

  var regionsEntries = Object.entries(regions);

  // TODO cambia selettore padre
  var parent;
  var rivenditori;

  if (what == 'orologi') {
    parent = document.querySelector('#rivenditori-orologi');
    rivenditori = rivenditoriOrologi;
  } else if (what == 'occhiali') {
    parent = document.querySelector('#rivenditori-occhiali');
    rivenditori = rivenditoriOcchiali;
  }

  rivenditori = rivenditori.sort(function (a, b) {

    if (a.PROV < b.PROV) { return -1; }
    if (a.PROV > b.PROV) { return 1; }

    if (a.PROV == b.PROV) {
      var insegna = rivenditori["NOME SU INSEGNA NEGOZIO"];
      var nome = insegna && insegna.length ? insegna : rivenditori["CLIENTE"];
      if (a.NOME < b.NOME) { return -1; }
      if (a.NOME > b.NOME) { return 1; }
    }

    return 0;
  });

  regionsEntries.forEach(entry => {
    var [regione, province] = entry;
    var rivenditoriPerRegion = rivenditori.filter((r) =>
      province.some((codiceProv) => codiceProv === r.PROV)
    );
    count = rivenditoriPerRegion.length;

    if (count > 0) {
      // crea una regione
      aggiungiRegione(regione);
      // filtra i rivenditori presenti nella regione
      rivenditoriPerRegion.forEach((rivenditore) => {
        // aggiunge i rivenditori presenti nella regione

        aggiungiRivenditore(rivenditore, document.querySelector(`#row-${regione}`));
      });
    }

  });


  function aggiungiRegione(regione) {
    parent.insertAdjacentHTML("beforeend", `
      <div class="row w-100 provincia" id="row-${regione}">
        <div class="col-12">
          <h3>${regione}</h3>
        </div>
      </div>
    `);
  }

  function aggiungiRivenditore(rivenditore, padreRegione) {
    var insegna = rivenditore["NOME SU INSEGNA NEGOZIO"];
    var nome = insegna && insegna.length ? insegna : rivenditore["CLIENTE"];
    var url = rivenditore["URL"];

    if (url && url.length) {

      padreRegione.insertAdjacentHTML("beforeend", `
      <div class="col-6 col-md-6 col-lg-4">
          <div class="location-item">
              <h4>${nome}</h4>
              <p><a href="${rivenditore.URL}" target="_blank" rel="nofollow">${rivenditore.WEBSITE}</a><br /><br /></p>
          </div>
      </div>
      `);
    } else {
      padreRegione.insertAdjacentHTML("beforeend", `
      <div class="col-6 col-md-6 col-lg-4">
          <div class="location-item">
              <h4>${nome}</h4>
              <p>${rivenditore.INDIRIZZO} <br /> ${rivenditore.CAP} ${rivenditore.CITTA} (${rivenditore.PROV})<br /></p>
          </div>
      </div>
      `);
    }

  }

}
